export default function (number: number | string, round = true): string {
  let tmp = number;
  if (round) {
    if (typeof tmp === 'string') tmp = parseInt(tmp, 10);
    else tmp = parseInt(String(tmp), 10);
  } else if (typeof tmp === 'string') tmp = parseFloat(tmp);
  else tmp = parseFloat(String(tmp));
  return tmp.toLocaleString();
}
